import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { Button } from "primereact/button";
import "./../Login.scss";
import LogoImg from "../../../Images/zbizLogo.png";
import { useFormik } from "formik";
import classNames from "classnames";
import { handlePostRequest } from "../../../services/PostTemplate";

const EmailSendRecover = ({ handleGenerateOtp }) => {
    let history = useHistory();

    const formik = useFormik({
        initialValues: {
            email: "",
        },
        validate: (data) => {
            let errors = {};

            if (!data.email) {
                errors.email = "Email is required.";
            }
            return errors;
        },
        onSubmit: async (data) => {
            try {
                await handlePostRequest(data, "zbizgateway/nonFin/sendEmailTOResetPwd");
                formik.resetForm();
                handleGenerateOtp();
            } catch (err) {
                console.log(err);
            }
        },
    });

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };

    return (
        <div className="Login__Body">
            <div className="container_login" id="container">
                <div className="form-container sign-in-container">
                    <form action="#" className="Login__Form" onSubmit={formik.handleSubmit}>

                        <div className="p-mb-4">
                            <h3 className="forgetHeading">FORGOT PASSWORD</h3>
                        </div>

                        <div className="p-mt-4">
                            <div className="p-text-left">
                                {/* <label htmlFor="email" className={classNames({ "p-error": isFormFieldValid("email") })}>
                                    Email
                                </label> */}
                                <input className={classNames({ "p-invalid": isFormFieldValid("email") }, "Login__Input")} name="email" placeholder="Enter Email" value={formik.values.email} onChange={formik.handleChange} type="email" />
                                {getFormErrorMessage("email")}
                            </div>

                            <div className="p-mt-4">
                                <Button className="Login__Button" label="Recover password" iconPos="right" />
                                <Button
                                    className="Login__Button"
                                    label="Back"
                                    onClick={() => {
                                        history.push("/");
                                    }}
                                />
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default EmailSendRecover;
